import React from 'react';

const MainFilterTop = (props) => {
  return (
    <div className="searchInnerFilterItem">
      <span className="searchInnerFilterTitle">{props.title}</span>
      <span className="searchMainFilterIcon filterView">
        <img src={props.eyeImage} alt="" />
      </span>
      {props.closeOff ? null : (
        <span className="searchMainFilterIcon filterClose">
          <img src={require('../../../assets/svg/DiamondList/close-theme.svg')} alt="" />
        </span>
      )}
    </div>
  );
};
export default MainFilterTop;
